import styled from 'styled-components'

import { ReactOverlayProps } from './type'

const ReactOverlay = styled.div<ReactOverlayProps>`
  display: ${(props) => (props.active ? `block` : `none`)};
  background-color: ${(props) => props.backgroundColor};
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: ${(props) => props.zIndex};
`

export default ReactOverlay
